<template>
  <ymap-marker
    :coords="[order.clientAddress.latGeo, order.clientAddress.letGeo]"
    :marker-id="order.code"
    marker-type="Placemark"
    :balloon-template="balloonTemplate"
    :balloon="{header: balloonHeader}"
    :icon="icon"
    cluster-name="1"
    :hint-content="hintContent"
  >
  </ymap-marker>
</template>

<script>
  import { ymapMarker } from 'vue-yandex-maps'
  import { DateTime } from 'luxon'
  import OrderStatus from '@/models/enums/OrderStatus'
  import { TRANSPARENT_PIXEL } from './marker-helpers'

  const ACTIVE_CALL_COLOR = '#DBDFE6'
  const FALLBACK_COLOR = '#333333'

  export default {
    name: 'OrderMarker',
    components: {
      ymapMarker,
    },
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      orderStatusDescription () {
        return this.order.orderStatusDescription || this.order.orderStatus
      },

      balloonTemplate () {
        let courierLabel = ''
        if (this.order.courier) {
          courierLabel = `<p class="baloon__courier">Курьер: ${this.order.courier.name}</p>`
        }
        return `
          <div class="balloon">
            <div class="balloon__info">
              <p class="balloon__id">ID ${this.order.id}</p>
              <p class="balloon__code"> Заказ #${this.order.code}</p>
              <p class="balloon__status">Статус: ${this.orderStatusDescription}</p>
              ${courierLabel}
            </div>

            <p class="balloon__adress">Адрес: ${this.order.clientAddress.shortAddress}</p>
          </div>`
      },
      balloonHeader () {
        return `#${this.order.code}, ${this.orderStatusDescription}: ${this.order.clientAddress.shortAddress}`
      },

      icon () {
        return {
          layout: 'default#imageWithContent',
          imageHref: TRANSPARENT_PIXEL,
          imageSize: [64, 41],
          imageOffset: [-32, -41],
          contentOffset: [0, 0],
          contentLayout: this.markerLayout,
        }
      },
      hintContent () {
        return `#${this.order.code}, ${this.orderStatusDescription}: ${this.order.clientAddress.shortAddress}`
      },

      statusItem () {
        return OrderStatus.statusColors[this.order.orderStatus] || null
      },
      // логика цвета - как в getBackgroundColor карточки заказа (Status.vue)
      markerColor () {
        if (this.order?.activeCall) {
          return ACTIVE_CALL_COLOR
        }
        if (this.order.isPreorder && this.statusItem?.colorPreorder) {
          return this.statusItem.colorPreorder
        }
        return this.statusItem?.color || FALLBACK_COLOR
      },
      isLate () {
        if (!this.order.deadLine) return false
        if (this.order.orderStatus === OrderStatus.Canceled) return false
        const deadline = DateTime.fromISO(this.order.deadLine)
        if (!deadline.isValid) return false
        const end = this.order.completedAt
          ? DateTime.fromISO(this.order.completedAt)
          : DateTime.local()
        return end > deadline
      },
      markerLayout () {
        const lateClass = this.isLate ? ' crm-order-marker__pin--late' : ''
        return `
          <div class="crm-order-marker">
            <div class="crm-order-marker__pin${lateClass}" style="background:${this.markerColor}">
              <span class="crm-order-marker__code">#${this.order.code}</span>
            </div>
            <svg class="crm-order-marker__tail" width="20" height="13" viewBox="0 0 20 13">
              <path d="M2 0 L10 11 L18 0 Z" fill="${this.markerColor}"/>
              <path d="M2 0 L10 11 L18 0" fill="none" stroke="#ffffff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>
            </svg>
          </div>`
      },
    },
  }
</script>

<style lang="less">
.crm-order-marker {
  width: 64px;
  height: 41px;
  text-align: center;

  // сплюснутая капля: пилюля с цветом статуса + остриё с белой окантовкой (svg)
  &__pin {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    height: 30px;
    padding: 0 12px;
    border: 2px solid #fff;
    border-radius: 15px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    &--late {
      animation: crm-order-marker-late-pulse 1.6s ease-in-out infinite;
    }
  }

  &__code {
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.3px;
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &__tail {
    display: block;
    margin: -2px auto 0;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
  }
}

@keyframes crm-order-marker-late-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 2px #ff005f, 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  50% {
    box-shadow: 0 0 0 2px rgba(255, 0, 95, 0.35), 0 2px 8px rgba(0, 0, 0, 0.3);
  }
}
</style>
